import { ViewboxOption } from './viewboxOption.model';

export class ViewboxOptionWithPrice<T> extends ViewboxOption<T> {
  priceChange?: any;

  constructor(selected: boolean, description: string, content: string, option: T, link?: string) {
    super(selected, description, content, option, link);
  }
}
